<script lang="ts">
    import { onMount } from "svelte";
    import ToolBoxModal from "../toolbox/ToolBoxModal.svelte";
    import { _ } from "svelte-i18n";
    import type { ScenarioShareToolBoxManager } from "./ScenarioShareToolBoxManager";
    import type { SharedScenarioData } from "../../../api/projects/data/sharing/SharedScenarioData";
    import { appManager } from "../../../AppManager";
    
    export let manager: ScenarioShareToolBoxManager;
    let sharedScenarios = manager.getSharedScenariosStore();
    let openToolBox = manager.getOpenToolBoxStore();

    onMount(async () => {
        await manager.initializeAsync();
    });
</script>

<ToolBoxModal
    isOpen={$openToolBox === "share"}
    title={$_("impact.map.share.toolbox.title")}>
    <div class="container">
        <div class="row mb-3">
            <div class="col-8">
                {$_("impact.map.share.toolbox.share")}
            </div>
            <div class="col-4">
                <button class="btn btn-xs btn-primary" on:click={async () => {
                    await manager.createNewShare();
                }}>
                    {$_("impact.map.share.toolbox.add")}
                </button>
            </div>
        </div>

        {#each $sharedScenarios as sharedScenario}
            <div class="row">
                <div class="d-flex">
                    <div class="mb-0  fs-tool">
                        <a
                            href={`${appManager.PublicUrl}shared/scenario/${sharedScenario.id}`}
                            target="_blank" rel="noreferrer">Link</a>
                    </div>

                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div
                        class="btn badge badge-rounded-circle badge-success-soft ms-auto"
                        on:click={async () => await manager.deleteShare(sharedScenario.id)}>
                        <i class="fe fe-trash-2" />
                    </div>
                </div>
            </div>
        {/each}
    </div>
</ToolBoxModal>

<style>
    .badge {
        font-size: 12.75px;
    }
</style>
